export default __webpack_public_path__ + "static/media/design-understandable.1ef5ff98.png";